"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../../../Druid");
const Draggable_1 = require("../../../Utility/Drag/Draggable");
class DialogUtil {
    /**
     * If the size of `element` is larger than the current viewport (taking into account the `margin` from the edge)
     * adjust the size of `sizer` element to reduce the width or height if necessary
     */
    static fitViewport(ui, options) {
        var _a;
        const element = ui.frame;
        const sizer = ui.content;
        const title = ui.headerTitle;
        const margin = (_a = options.edgeMargin) !== null && _a !== void 0 ? _a : 10;
        // remove max width/height
        sizer.style.maxWidth = '';
        sizer.style.maxHeight = '';
        const elDim = { w: element.getWidth('outer'), h: element.getHeight('outer') };
        const sizerDim = { w: sizer.getWidth(), h: sizer.getHeight() };
        // determine max width of the frame
        let maxWidth = window.innerWidth - margin;
        if (options.maxWidth && typeof options.maxWidth === 'number') {
            maxWidth = Math.min(maxWidth, options.maxWidth);
        }
        // determine max height of the frame
        let maxHeight = window.innerHeight - margin;
        if (options.maxHeight && typeof options.maxHeight === 'number') {
            maxHeight = Math.min(maxHeight, options.maxHeight);
        }
        // take w,h difference from element + sizer into account;
        maxWidth -= elDim.w - sizerDim.w;
        maxHeight -= elDim.h - sizerDim.h;
        // set the preferred max size
        sizer.style.maxWidth = maxWidth + 'px';
        sizer.style.maxHeight = maxHeight + 'px';
        // set the preferred max width for the title
        title.style.maxWidth = maxWidth + 'px';
    }
    /**
     * Set the `element` position based on the parent element size
     */
    static center(element, parent) {
        let scrollLeft = (parent.clientWidth - element.offsetWidth) / 2;
        let scrollTop = (parent.clientHeight - element.offsetHeight) / 2;
        // make sure the top Dialog is within the document
        scrollLeft = Math.max(0, scrollLeft);
        scrollTop = Math.max(0, scrollTop);
        element.style.left = scrollLeft + 'px';
        element.style.top = scrollTop + 'px';
    }
    /**
     * Initialize interact on the frame and enable dragging
     */
    static makeDraggable(frame, overlay, handle) {
        const position = { x: 0, y: 0 };
        const bounds = { minX: 0, maxX: 0, minY: 0, maxY: 0 };
        const margin = { top: 5, right: 20, bottom: 10, left: 5 };
        // add draggable css styles
        frame.classList.add('draggable');
        // initialize draggable
        return new Draggable_1.default(frame, {
            handle: handle,
            onStart: () => {
                // determine initial frame position
                position.x = Math.max(0, parseInt(frame.style.left || '0'));
                position.y = Math.max(0, parseInt(frame.style.top || '0'));
                // determine viewport bounds
                bounds.minX = margin.left;
                bounds.minY = margin.top;
                bounds.maxX = overlay.getWidth('outer') - frame.getWidth('outer') - margin.right;
                bounds.maxY = overlay.getHeight('outer') - frame.getHeight('outer') - margin.bottom;
            },
            onDragMove: (event) => {
                // restrict to viewport
                const x = Math.max(bounds.minX, Math.min(bounds.maxX, position.x + event.dx));
                const y = Math.max(bounds.minY, Math.min(bounds.maxY, position.y + event.dy));
                // update css
                frame.style.left = x + 'px';
                frame.style.top = y + 'px';
            }
        }).attach();
    }
    /**
     * Set the preferred dimensions of the dialog based on the options
     */
    static setupDimensions(content, options) {
        const css = (value, defaultValue) => {
            if (value === undefined) {
                return defaultValue;
            }
            if (typeof value === 'number') {
                return value + 'px';
            }
            return value;
        };
        content.style.width = css(options.width, '');
        content.style.height = css(options.height, '');
        content.style.minWidth = css(options.minWidth, '200px');
        content.style.maxWidth = css(options.maxWidth, '');
        content.style.minHeight = css(options.minHeight, '200px');
        content.style.maxHeight = css(options.maxHeight, '');
    }
}
exports.default = DialogUtil;
//# sourceMappingURL=DialogUtil.js.map